module.exports = __webpack_public_path__ + "img/sh_ig-y.451154a0.svg";